import { isEarlyCacheReturnEnabled } from '../earlyCacheReturn';
import { Metrics } from '../metrics';
import { associationDefinitionsPersistedPromise } from 'fdsr-migration-layer';
export const makeAssociationDefinitionsClient = ({
  rpcClient,
  persistedPromise = associationDefinitionsPersistedPromise
}) => Promise.resolve({
  debug: () => {
    persistedPromise.debug();
  },
  clearCache: () => {
    persistedPromise.clearCache();
    return Promise.resolve();
  },
  get: ({
    frameworkTypeIdentifier
  }) => {
    Metrics.counter('associationDefinitions.get').increment();
    return persistedPromise.makeFetchWithOpts({
      allowEagerCacheReturn: isEarlyCacheReturnEnabled()
    })({
      rpcClient,
      frameworkTypeIdentifier
    });
  }
});